import React from 'react';
export const ProductIntroSection = () => {
  const bullets = ['Sistema completo por nivel y condición de salud', 'Actividades para el adulto mayor + guía para el cuidador', 'Bitácoras reales de salud para llevar al médico', 'Adaptado a Alzheimer, Parkinson, Diabetes e Hipertensión'];
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-179">
      <div className="max-w-5xl mx-auto text-center w-[92%] md:w-full" data-id="element-180">
        <div className="inline-block bg-familia-cyan text-familia-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-181">
          📚 El Sistema de Bienestar Senior Más Completo de Argentina y LATAM
        </div>
        <h2 className="text-4xl sm:text-6xl md:text-7xl font-display font-bold mb-2" data-id="element-182">
          VITALIDAD 360™
        </h2>

        <p className="text-familia-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-183">
          5 Módulos + Módulo vip +150 ejercicios + 3 Bonos —{' '}
          <span className="text-white font-bold" data-id="element-184">
            Estimulación para el adulto mayor.
          </span>{' '}
          <span className="text-familia-gold font-bold" data-id="element-185">
            Organización para el cuidador. Tranquilidad para toda la familia.
          </span>
        </p>
        <div className="bg-familia-card border border-familia-cyan/15 p-6 md:p-12 rounded-3xl mb-10 md:mb-16" data-id="element-186">
          <p className="text-familia-gray text-[15px] md:text-lg mb-8 md:mb-12 leading-relaxed" data-id="element-187">
            · 5 módulos completos · Módulo Vip +150 ejercicios · 3 bonos · Mente
            Despierta · Movilidad Sin Miedo · Cuidado Experto · Bitácora de
            Control · Guía del Cuidador · Nutrición 60+ · Kit de Socialización ·
            Checklist Hogar Seguro · Actividades por niveles en cada página.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto" data-id="element-188">
            {bullets.map((b, i) => <div key={i} className="flex items-center gap-3" data-id="element-189">
                <span className="text-familia-green text-xl" data-id="element-190">✅</span>
                <span className="font-bold text-[15px] sm:text-base" data-id="element-191">{b}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};